<template>
    <div class="header">
      <ul class="nav navbar-nav navbar-right">
        <li v-if="!isAuthenticated" @click="authenticate()">Увійти</li>
        <li v-if="isAuthenticated" @click="signout()">Вийти з аккаунта</li>
      </ul>
    </div>
</template>

<script>

import auth from '../services/auth'

export default {
  name: 'profile',
  computed: {
    isAuthenticated: function () {
      return this.$store.getters.isAuthenticated
    }
  },
  methods: {
    authenticate () {
      auth.authenticate()
    },
    signout () {
      this.$store.dispatch('signout').then(() => {
        this.$router.push({ name: 'login' })
      })
    }
  }
}
</script>

<style>
.header li {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// Profile.vue?05c783b6